// src/App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import ManageRSSFeeds from './components/ManageRSSFeeds';
import DisplayArticles from './components/DisplayArticles';
import FetchRSS from './components/FetchRSS';
import { CssBaseline, AppBar, Toolbar, Typography, Button, IconButton, Menu, MenuItem } from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { FeedbackProvider } from './contexts/FeedbackContext';
import FeedbackMessage from './components/FeedbackMessage';
import { SpinnerProvider } from './contexts/SpinnerContext';
import { MetadataProvider } from './contexts/MetadataContext';
import { ArticlesProvider } from './contexts/ArticlesContext';
//import { onAuthStateChanged, signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut } from 'firebase/auth';
//import { doc, getDoc } from 'firebase/firestore';
//import db from './firebase'; // Import your Firestore instance
import Login from './components/Login'; // Assuming you have a Login component
import Signup from './components/Signup'; // Assuming you have a Signup component
import NewsletterGenerator from './components/NewsletterGenerator';
import Admin from './components/Admin';
import PendingApproval from './components/PendingApproval'; // Create this component to inform users their account is pending approval
import ApiLogs from './components/ApiLogs';
//import MetadataConfig from './components/MetadataConfig';
import ProcessArticles from './components/ProcessArticles';
import HomePage from './pages/HomePage';
import ConfigPage from './pages/ConfigPage';
//import { Article } from '@mui/icons-material';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import './styles/global.css'; // Import the global CSS file
//import SearchComponent from './components/SearchComponent';
import LogoutSuccess from './components/LogoutSuccess'; // Create this component to inform users they have logged out successfully
import { useNavigate } from 'react-router-dom';
import { useScrollTrigger, Slide } from '@mui/material';
import LogoutRoute from './components/LogoutRoute';
import ManualArticleSubmission from './components/ManualArticleSubmission';

const theme = createTheme({
  palette: {
    mode: 'light', // You can change this to 'dark' if needed
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function HideOnScroll({ children }) {
  const trigger = useScrollTrigger();

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

const AuthenticatedApp = () => {
  //const [user, setUser] = useState(null);
  const { currentUser, handleLogout } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuLogout = async () => {
    try {
      await handleLogout();
      navigate('/logout-success');
    }
    catch (error) {
      console.error('Logout error:', error);
    };
    handleMenuClose();
  };

  /* useEffect(() => {
     const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
       if (currentUser) {
         const userDoc = await getDoc(doc(db, 'users', currentUser.uid));
         if (userDoc.exists()) {
           setUser({ ...currentUser, ...userDoc.data() });
         } else {
           setUser(currentUser);
         }
       } else {
         setUser(null);
       }
     });
 
     return () => unsubscribe();
   }, []);
 
   const handleLogout = () => {
     setUser(null);
     signOut(auth)
       .then(() => {
         // Handle successful logout (e.g., redirect to login page)
         console.log('Logged out successfully!');
       })
       .catch((error) => {
         // Handle logout errors
         console.error('Logout error:', error);
       });
     handleMenuClose();
   };
 */

  return (
    <MetadataProvider user={currentUser}>
      <FeedbackProvider>
        <ArticlesProvider user={currentUser}>
          <CssBaseline />
          <HideOnScroll>
            <AppBar>
              <Toolbar>
                <Typography variant="h6" style={{ flexGrow: 1 }}>
                  <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
                    The Climate Spectrum
                  </Link>
                </Typography>

                {currentUser ? (
                  <>
                    {currentUser.isAdmin ? (
                      <>
                        <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleMenuOpen}>
                          <MenuIcon />
                        </IconButton>
                        <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleMenuClose}>
                          <MenuItem component={Link} to="/articles" onClick={handleMenuClose}>Display Articles</MenuItem>
                          <MenuItem component={Link} to="/add-article" onClick={handleMenuClose}>Add Article</MenuItem>
                          <MenuItem component={Link} to="/manage-rss-feeds" onClick={handleMenuClose}>Manage RSS Feeds</MenuItem>
                          <MenuItem component={Link} to="/fetch" onClick={handleMenuClose}>Fetch RSS Feeds</MenuItem>
                          <MenuItem component={Link} to="/process" onClick={handleMenuClose}>Process articles</MenuItem>
                          <MenuItem component={Link} to="/newsletter" onClick={handleMenuClose}>Generate Newsletter</MenuItem>
                          <MenuItem component={Link} to="/apilogs" onClick={handleMenuClose}>Logs</MenuItem>
                          <MenuItem component={Link} to="/config" onClick={handleMenuClose}>Config</MenuItem>
                          <MenuItem component={Link} to="/admin" onClick={handleMenuClose}>Admin</MenuItem>
                          <MenuItem onClick={handleMenuLogout} id="logout">Logout</MenuItem>
                        </Menu>
                      </>
                    ) : (
                      // Non-admin user
                      <Button color="inherit" onClick={handleMenuLogout} id="logout">Logout</Button>
                    )}
                  </>
                ) : (
                  // Not logged in
                  <>
                    <Button color="inherit" component={Link} to="/login" id="loginbutton">Login</Button>
                    <Button color="inherit" component={Link} to="/signup">Signup</Button>
                  </>
                )}
              </Toolbar>
            </AppBar>
          </HideOnScroll>
          {/* Add toolbar spacing to prevent content jump */}
          <Toolbar />
          {currentUser && currentUser.isAdmin ? (
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/theclimatespectrum" element={<HomePage />} />
              <Route path="/manage-rss-feeds" element={<ManageRSSFeeds />} />
              <Route path="/articles" element={<DisplayArticles />} />
              <Route path="/apilogs" element={<ApiLogs />} />
              <Route path="/fetch" element={<FetchRSS />} />
              <Route path="/process" element={<ProcessArticles />} />
              <Route path="/newsletter" element={<NewsletterGenerator />} />
              <Route path="/config" element={<ConfigPage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/pending-approval" element={<PendingApproval />} /> {/* Add the route for PendingApproval */}
              <Route path="/admin" element={<Admin />} />
              <Route path="/logout" element={<LogoutRoute />} />
              <Route path="/logout-success" element={<LogoutSuccess />} />
              <Route path="/add-article" element={<ManualArticleSubmission /> } />
            </Routes>
          ) : (
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/theclimatespectrum" element={<HomePage />} />
              <Route path="/articles" element={<DisplayArticles />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/pending-approval" element={<PendingApproval />} /> {/* Add the route for PendingApproval */}
              <Route path="/logout" element={<LogoutRoute />} />
              <Route path="/logout-success" element={<LogoutSuccess />} />
            </Routes>
          )}
          <FeedbackMessage />
        </ArticlesProvider>
      </FeedbackProvider>
    </MetadataProvider>
  );
};

const App = () => {
  return (
    <ThemeProvider theme={theme} >
      <AuthProvider>
        <SpinnerProvider>
          <Router> {/* Move BrowserRouter here */}
            <AuthenticatedApp />
          </Router>
        </SpinnerProvider>
      </AuthProvider>
    </ThemeProvider >
  );
};

export default App;
